import React, {FC} from "react";

interface ruleProps {
    text: string
}

export const PackageRulesHeaderMain: FC<ruleProps> = ({text}) => {
    if (!text) {
        return null;
    }
    return (
        <div className={"packages_rules_item header_main"}>{text}</div>
    )
}